<p-dialog
  *transloco="let t"
    [header]="engagement?.engagementName || ''"
  [visible]="showing"
  (visibleChange)="showingChange.emit($event)"
  [resizable]="false"
  [blockScroll]="true"
  appendTo="body">

    <h2 *transloco="let t">{{ t('request_access') }}</h2>
    <div class="flex">
        <div class="w-full">
            <p-multiselect
                [(ngModel)]="approveUsers"
                [placeholder]="this.loadingUsersWithoutAccess ? t('loading') : t('select_user')"
                styleClass="w-full"
                [disabled]="this.loadingUsersWithoutAccess"
                [options]="usersWithoutAccess"
                [(ngModel)]="approveUsers" 
                optionLabel="displayName"
                filterBy="displayName,userEmail"
                appendTo="body">
                <ng-template #item let-user>
                    <div>
                        <div>{{user.displayName}}</div>
                        <div class="text-xs">{{ user.userEmail }}</div>
                    </div>
                </ng-template>
            </p-multiselect>
        </div>
        <div class="flex-none">
            <p-button
                (onClick)="createAccessRequests()"
                *transloco="let t"
                [loading]="requestLoading"
            >
                {{ t('send_request') }}
            </p-button>
        </div>
    </div>

    <p-table
        *transloco="let t"
        [value]="approvedAndPendingUsers"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="['name', 'jobCode', 'managerName']"
        sortField=""
        [sortOrder]="-1"
        styleClass="p-datatable-sm log-table mt-3"
        dataKey="id"
        >
        <ng-template #header>
            <tr>
                <th pSortableColumn="engagementName">
                    {{ t("name") }} <p-sortIcon field="engagementUserName"></p-sortIcon>
                </th>
                <th pSortableColumn="userType">
                    {{ t("user_type") }} <p-sortIcon field="userType"></p-sortIcon>
                </th>
                <th pSortableColumn="jobCode">
                    {{ t("email") }} <p-sortIcon field="engagementUserEmail"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-engagementEntry
        >
            <tr attr.data-instanceid="{{ engagementEntry.instanceId }}">
            <td>
                <span class="font-medium">{{ engagementEntry.engagementUserName }}</span>
            </td>
            <td>
                <span>{{ engagementEntry.userType }}</span>
            </td>
            <td>
                <span>{{ engagementEntry.engagementUserEmail }}</span>
            </td>
            </tr>
        </ng-template>
        <ng-template #emptymessage>
            <tr>
            <td [attr.colspan]="6">
                <p
                class="p-12 italic font-normal text-center text-grey-medium/50"
                >
                {{ loading ? t('loading') : t('empty_message') }}
                </p>
            </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>